/*
 * variant-swatches.js
 * Leaga swatch-urile native (snippet variant-swatches.liquid) de selectoarele
 * temei. Click pe swatch => seteaza .single-option-selector corespunzator si
 * declanseaza "change", lasand clasa Variants din theme.min.js sa actualizeze
 * varianta, imaginea, pretul si SKU-ul.
 */
(function () {
  'use strict';

  function selectSwatch(group, btn) {
    var targetId = group.getAttribute('data-target-selector');
    var select = document.getElementById(targetId);
    if (!select) return;

    var value = btn.getAttribute('data-swatch-value');

    group.querySelectorAll('.variant-swatch').forEach(function (b) {
      var isActive = b === btn;
      b.classList.toggle('variant-swatch--selected', isActive);
      b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    var wrapper = group.closest('.selector-wrapper');
    var currentValueEl = wrapper && wrapper.querySelector('.variant-swatches__current-value');
    if (currentValueEl) currentValueEl.textContent = value;

    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function bindGroup(group) {
    group.querySelectorAll('.variant-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectSwatch(group, btn);
      });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-variant-swatches]').forEach(bindGroup);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  }

  window.initVariantSwatches = init;
})();
